import { Col, Row, Space } from 'antd';
import { useSelector } from 'react-redux';
import { selectors } from 'app/services/projects/slice';

import StatusTag from 'pages/Sites/components/StatusTag';
import SendEmail from './Actions/SendEmail';
import ChangeSite from './Actions/ChangeSite';
import Delete from './Actions/Delete';
import Edit from './Actions/Edit';
import Close from './Actions/Close';
import Open from './Actions/Open';
import Restore from './Actions/Restore';
import Actions from 'components/Actions/Actions';
import downloadReportButtons from './Actions/DownloadReportButtons';
import { useState } from 'react';
import { ProjectReportType } from 'constants/project';
import ReportLanguageModal from './Actions/ReportLanguageModal';
import { useLazyGetProjectReportQuery } from 'app/services/projects';

const Header = () => {
  const project = useSelector(selectors.getProject);
  const [ startReportDownload, { isFetching } ] = useLazyGetProjectReportQuery();
  const [ lastType, setLastType ] = useState<ProjectReportType | undefined>(undefined);
  const [ open, setOpen ] = useState(false);

  if (!project) return null;

  const onDownloadClick = (type: ProjectReportType) => {
    setLastType(type);
    setOpen(true);
  };

  const reportButtons = downloadReportButtons({
    isExecuting: undefined,
    lastType,
    onClick: onDownloadClick,
    downloadReport: startReportDownload,
    isFetching });

  const actions = [
    ...reportButtons,
    <SendEmail key='send' />,
    <ChangeSite projectId={project.Id} key='change' />,
    <Edit projectId={project.Id} key='edit' />,
    <Delete key='delete' />,
    <Restore key='restore' />,
    <Close key='close' />,
    <Open key='open' />
  ];

  return (
    <Row justify="space-between">
      <Col>
        <Space>
          <div className="title">{project.WorkPlace}</div>
          {project && <StatusTag state={project.State} />}
        </Space>
      </Col>
      <Col>
        {open && <ReportLanguageModal
          projectId={project.Id}
          reportType={lastType}
          open={open}
          setOpen={setOpen}
          onOk={startReportDownload}
          isFetching={isFetching}/>
        }
        <Actions actions={actions} />
      </Col>
    </Row>
  );
};

export default Header;